import * as React from "react";
import * as ReactDOM from "react-dom";
import classnames from "classnames";
import moment from "moment";

import { assertValue } from "../../../utils/assert";
import { VehicleGeoposition, Geoposition } from "../../../../rest/GetVehiclesGeoposition";

// const styles = require('./GoogleMap.local.css');
type LatLng = google.maps.LatLng;
type LatLngBounds = google.maps.LatLngBounds;
interface Props
{
    className?: string;
    defaultZoom: number;
    Vehicles: VehicleGeoposition[];
}

export class VehicleGoogleMap extends React.Component<Props>
{
    private mapRef: HTMLDivElement;
    private map: google.maps.Map;

    componentDidMount()
    {
        assertGoogleScriptTag();
        this.updateMap();
    }
    
    render()
    {
        return <div style={{minHeight: '400px'}} className={classnames(this.props.className, /*styles.GoogleMap*/)} ref={e => this.mapRef = e} />
    }

    private updateMap ()
    {
        assertValue(this.mapRef);
        
        const { defaultZoom, Vehicles } = this.props;

        let center: LatLng;
        let bounds: LatLngBounds;
        const vehicleGeopositions = Vehicles.filter(v => Array.isArray(v.Geoposition) && v.Geoposition.length > 0)
        const locations = vehicleGeopositions.map(v => v.Geoposition[v.Geoposition.length-1]);        
        if(locations.length > 1) {
            bounds = new google.maps.LatLngBounds();
            locations.map(getLatLngFrom).forEach(ll => bounds.extend(ll));
            center = bounds.getCenter();
        } else if (locations.length === 1) {
            center = getLatLngFrom(locations[0]);
        } else {
            throw new Error('no data to display');
        }
        this.map = new google.maps.Map(this.mapRef, {
            center,
            zoom: defaultZoom,
        });
        if(bounds) {
            this.map.fitBounds(bounds);
        }

        vehicleGeopositions.forEach(vg => {
            const lastPosition = vg.Geoposition[vg.Geoposition.length - 1];
            const timestamp = moment(lastPosition.DateTime).format('YYYY-MM-DD HH:mm:ss')
            new google.maps.Marker({
                position: getLatLngFrom(lastPosition),
                map: this.map,
                title: `${vg.Display}\n${timestamp}`
            });
        });
    }
}

function getLatLngFrom(geo: Geoposition) {
    return new google.maps.LatLng(geo.Latitude, geo.Longitude);
}

function assertGoogleScriptTag()
{
    if(!window['google'])
        throw new Error('you have to add/inject <script src="https://maps.googleapis.com/maps/api/js?key=...></script>');
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/VehicleMap/Map.tsx